import map from "lodash/map"

class FilterFlat {
  constructor(flatJSON) {
    this.flatJSON = flatJSON;
  }

  getHousing() {
    return this.flatJSON['housingName'];
  }

  getHousingShort() {
    return this.flatJSON['housingShortName'];
  }

  getSection() {
    return this.flatJSON['sectionNumber'];
  }

  getFloor() {
    return this.flatJSON['floorNumber'];
  }

  getRoomCount() {
    return this.flatJSON['rooms']['short'];
  }

  getRoomFullName() {
    return this.flatJSON['rooms']['title'];
  }

  getSpace() {
    return this.flatJSON['space'];
  }

  getPrice() {
    return Math.round((this.flatJSON['price']) / 10000) / 100;
  }

  getUrl() {
    return this.flatJSON['url'];
  }

  getFinish() {
    if(this.flatJSON['finish']) {
      return this.flatJSON['finish'];
    }
  }
}

export class GetFilterFlatsResponse {
  constructor(responseJSON) {
    this.responseJSON = responseJSON;
  }

  getFlats() {
    return map(this.responseJSON['apartments'], (responseItem) => {
      return new FilterFlat(responseItem)
    });
  }

  getSortingBy() {
    return this.responseJSON['sort']['by'];
  }

  getSortingOrder() {
    return this.responseJSON['sort']['order'];
  }
}



// WEBPACK FOOTER //
// ./js/api/GetFilterFlatsResponse.js